import styled from 'styled-components';
import { cardBackground, darkgrey } from 'styles/Colors';
import { SectionHeadlineWrapper } from '../SectionHeadline/SectionHeadlineStyles';

export const MetricsWrapper = styled.div`
  height: 100%;

  ${SectionHeadlineWrapper} {
    display: flex;
  }

  .MuiPaper-root {
    padding: 6px 5px !important;
    height: 100%;
    overflow-y: auto;
    background: ${cardBackground};
    @media screen and (-webkit-min-device-pixel-ratio: 0) {
      overflow: hidden;
      &:hover {
        overflow-y: scroll;
      }
      &::-webkit-scrollbar {
        width: 2px;
      }
      &::-webkit-scrollbar-track {
        border-radius: 3.5px;
      }
      &::-webkit-scrollbar-thumb {
        background-image: linear-gradient(179deg, ${darkgrey}, rgba(65, 65, 65, 0.82));
        border-radius: 3.5px;
      }
    }
  }
`;

export const FilterIconWrapper = styled.span`
  cursor: pointer;
  svg {
    position: absolute;
    right: 15px;
    top: -5px;
  }
`;
